import {
	AdvancedProductFilter,
	AttributeFilter,
	CategoryTypeFilter,
	PriceRangeFilter,
	PromotionFilter,
	RecommendedByCategory,
	SearchFilter,
} from '@/entities/api/products/product-filters'
import { API_URL, CUSTOMERS_KEY } from '../keys'
import axios from 'axios'

const BASE_URL = `${API_URL}/products/filter`

const defaultHeaders = {
	'sce-api-key': CUSTOMERS_KEY,
	'Content-Type': 'application/json',
}

const defaultConfig = {
	headers: defaultHeaders,
	validateStatus: (status: number) => status < 500,
}

export const fetchProductById = async (id: string) => {
	const response = await axios.get(`${API_URL}/products/${id}`, defaultConfig)
	if (response) return response
}

export const filterByPriceRange = async (data: PriceRangeFilter) => {
	const response = await axios.post(
		`${BASE_URL}/price-range`,
		data,
		defaultConfig
	)
	if (response) return response
}

export const filterByAttributes = async (data: AttributeFilter) => {
	const response = await axios.post(
		`${BASE_URL}/attributes`,
		data,
		defaultConfig
	)
	if (response) return response
}

export const filterByPromotions = async (data: PromotionFilter) => {
	const response = await axios.post(
		`${BASE_URL}/promotions`,
		data,
		defaultConfig
	)
	if (response) return response
}

export const filterByCategoryAndType = async (data: CategoryTypeFilter) => {
	const response = await axios.post(
		`${BASE_URL}/category-type`,
		data,
		defaultConfig
	)
	if (response) return response
}

export const intelligentSearch = async (data: SearchFilter) => {
	const response = await axios.post(`${BASE_URL}/search`, data, defaultConfig)
	if (response) return response
}

export const advancedFilter = async (data: AdvancedProductFilter) => {
	const response = await axios.post(`${BASE_URL}/advanced`, data, defaultConfig)
	if (response) return response
}

export const getBestDeals = async (limit?: number) => {
	const response = await axios.get(`${BASE_URL}/best-deals`, {
		...defaultConfig,
		params: limit ? { limit } : {},
	})
	if (response) return response
}

export const getFilterStatistics = async () => {
	const response = await axios.get(`${BASE_URL}/statistics`, defaultConfig)
	if (response) return response
}

export const quickSearch = async (q: string, page?: number, limit?: number) => {
	const response = await axios.get(`${BASE_URL}/quick-search`, {
		...defaultConfig,
		params: { q, page, limit },
	})
	if (response) return response
}

export const getRecommendedByCategory = async (data: RecommendedByCategory) => {
	const response = await axios.post(
		`${BASE_URL}/recommended-by-category`,
		data,
		defaultConfig
	)
	if (response) return response
}

export const filterMultiCriteria = async (data: AdvancedProductFilter) => {
	const response = await axios.post(
		`${BASE_URL}/multi-criteria`,
		data,
		defaultConfig
	)
	if (response) return response
}
